(() => {
  if (window.artbiteAddressSearchInstalled) return;
  window.artbiteAddressSearchInstalled = true;
  let library;
  function loadPlaces() {
    if (window.google?.maps?.importLibrary) return window.google.maps.importLibrary('places');
    if (!library) {
      library = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timeout = setTimeout(() => reject(new Error('Address search timeout')), 15000);
        window.artbitePlacesReady = () => {
          clearTimeout(timeout);
          window.google.maps.importLibrary('places').then(resolve, reject);
        };
        script.async = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBtvYODqqClw1OpxMjD4wTgOspDOEKAYW0&loading=async&v=weekly&libraries=places&callback=artbitePlacesReady';
        script.onerror = () => {
          clearTimeout(timeout);
          reject(new Error('Address search unavailable'));
        };
        document.head.appendChild(script);
      });
    }
    return library;
  }
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-artbite-search-start]');
    if (!button || button.disabled) return;
    const host = button.closest('[data-artbite-address-search]');
    const form = host.closest('form');
    const status = host.querySelector('[data-artbite-search-status]');
    button.disabled = true;
    status.textContent = host.dataset.loading;
    try {
      const { PlaceAutocompleteElement } = await loadPlaces();
      if (!host.isConnected) return;
      const widget = new PlaceAutocompleteElement({
        includedRegionCodes: ['ca'],
        locationBias: { center: { lat: 49.2606, lng: -123.1487 }, radius: 15000 }
      });
      widget.placeholder = host.dataset.placeholder;
      widget.setAttribute('aria-label', host.dataset.placeholder);
      widget.style.width = '100%';
      widget.style.colorScheme = 'light';
      widget.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') e.preventDefault();
      });
      let selection = 0;
      widget.addEventListener('gmp-select', async ({ placePrediction }) => {
        const current = ++selection;
        status.textContent = host.dataset.loading;
        try {
          const place = placePrediction.toPlace();
          await place.fetchFields({ fields: ['addressComponents'] });
          if (current !== selection || !host.isConnected) return;
          const components = place.addressComponents || [];
          const part = (type, short = false) => {
            const item = components.find((component) => component.types.includes(type));
            return item ? (short ? item.shortText : item.longText) || '' : '';
          };
          const validRegion = part('country', true) === 'CA' && part('administrative_area_level_1', true) === 'BC';
          const values = validRegion ? {
            'Recipient Address': [part('street_number'), part('route')].filter(Boolean).join(' '),
            'Recipient City': part('locality') || part('postal_town') || part('sublocality_level_1'),
            'Recipient Postal Code': part('postal_code').toUpperCase()
          } : { 'Recipient Address': '', 'Recipient City': '', 'Recipient Postal Code': '' };
          Object.entries(values).forEach(([name, value]) => {
            const input = form.elements.namedItem(name);
            input.value = value;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          const prefix = values['Recipient Postal Code'].replace(/\s/g, '').slice(0, 3);
          status.textContent = !validRegion || (prefix && !form.dataset.deliveryPrefixes.split(',').includes(prefix))
            ? host.dataset.region : host.dataset.review;
        } catch {
          if (current === selection) status.textContent = host.dataset.unavailable;
        }
      });
      widget.addEventListener('gmp-error', () => { status.textContent = host.dataset.unavailable; });
      host.querySelector('[data-artbite-search-widget]').appendChild(widget);
      button.hidden = true;
      status.textContent = '';
    } catch {
      status.textContent = host.dataset.unavailable;
      button.disabled = false;
    }
  });
})();
